import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
	routes: [
	{
		path: '/',
		component: function() { return import( /* webpackChunkName: "Other" */ './views/Other.vue') },
		props: function(route) {
			return route.meta;
		},
		children: [
			{
				path: '',
				name: 'Dashboard',
				components: {
					default: function() { return import( './components/Pages/DashboardLive.vue') }
				},
				meta: { auth: true, backTop: true },
			},
			{
				path: 'item/:post_id/:text?',
				name: 'SinglePost',
				components: {
					default: function() { return import( './components/Pages/SinglePost.vue') }
				},
				meta: { auth: true, backTop: true },
			},
			{
				path: 'content/:post_id/:text?',
				name: 'SinglePost',
				components: {
					default: function() { return import( './components/Pages/SinglePost.vue') }
				},
				meta: { auth: true, backTop: true },
			},
			{
				path: 'live',
				name: 'DashboardLive',
				components: {
					default: function() { return import( './components/Pages/DashboardLive.vue') }
				},
				meta: { auth: true, backTop: true },
			},
			{
				path: '/',
				component: function() { return import( /* webpackChunkName: "Other" */ './views/Businesses.vue') },
				props: function(route) { return route.meta; },
				children: [
					{ 
						path: 'categories', 
						name: 'CategoriesIndex', 
						components: { default: function() { return import( './components/Pages/Categories.vue') } }, 
						meta: { auth: true, backTop: true, grouping: 'CategoriesIndex' } 
					},
					{ 
						path: 'new-companies', 
						name: 'CompaniesNew', 
						components: { default: function() { return import( './components/Pages/BusinessList.vue') } }, 
						meta: { auth: true, backTop: true, grouping: 'CategoriesIndex', type: 'new' } 
					},
					{ 
						path: 'companies-offers', 
						name: 'CompaniesOffers', 
						components: { default: function() { return import( './components/Pages/BusinessList.vue') } }, 
						meta: { auth: true, backTop: true, grouping: 'CategoriesIndex', type: 'offer' } 
					},
					{ 
						path: 'category/:category_id', 
						name: 'CategoriesGet', 
						components: { default: function() { return import( './components/Pages/Category.vue') } }, 
						meta: { auth: true, backTop: true, slideNav: true, grouping: 'CategoriesIndex' } 
					},
					{ 
						path: 'company/:business_id', 
						name: 'CompaniesGet', 
						components: { default: function() { return import( './components/Pages/Business.vue') } }, 
						meta: { auth: true, backTop: true, slideNav: true, grouping: 'CategoriesIndex' } 
					},
				]
			},
			{
				path: 'company/:business_id/review',
				name: 'CompaniesReview',
				components: {
					default: function() { return import( './components/Pages/Review.vue') }
				},
				meta: { auth: true, backTop: true },
			},
			{
				path: 'offers',
				name: 'Offers',
				components: {
					default: function() { return import( './components/Pages/Offers.vue') }
				},
				meta: { auth: true, backTop: true },
			},
			{
				path: 'videos',
				name: 'Videos',
				components: {
					default: function() { return import( './components/Pages/Videos.vue') }
				},
				meta: { auth: true, backTop: true },
			},
			{
				path: 'messages',
				name: 'Messages',
				components: {
					default: function() { return import( './components/Pages/Messages.vue') }
				},
				meta: { auth: true, backTop: true },
			},
			{
				path: 'messages/thread/:thread',
				name: 'MessagesThread',
				components: {
					default: function() { return import( './components/Pages/Messages.vue') }
				},
				meta: { auth: true, backTop: true, detail: true },
			},
			{
				path: 'favourites',
				name: 'Favourites',
				components: {
					default: function() { return import( './components/Pages/Favourites.vue') }
				},
				meta: { auth: true, backTop: true },
			},
			{
				path: '/',
				component: function() { return import( /* webpackChunkName: "Other" */ './views/Account.vue') },
				props: function(route) { return route.meta; },
				children: [
					{
						path: 'my-offers',
						name: 'MyOffers',
						components: {
							default: function() { return import( './components/Pages/MyOffers.vue') }
						},
						meta: { auth: true, backTop: true },
					},
					{
						path: 'my-company',
						name: 'MyCompany',
						components: {
							default: function() { return import( './components/Pages/MyCompany.vue') }
						},
						meta: { auth: true, backTop: true },
					},
					{
						path: 'my-account',
						name: 'MyAccount',
						components: {
							default: function() { return import( './components/Pages/MyAccount.vue') }
						},
						meta: { auth: true, backTop: true },
					},
					{
						path: 'account-expired',
						name: 'AccountExpired',
						components: {
							default: function() { return import( './components/Pages/MyAccount.vue') }
						},
						meta: { auth: true, backTop: true, expired: true },
					}
				]
			}
		]
	},
	{
		path: '/',
		component: function() { return import( /* webpackChunkName: "Other" */ './views/OtherUnloggedTwo.vue') },
		props: function(route) {
			return route.meta;
		},
		children: [
			{
				path: 'join/:key',
				name: 'UserJoin',
				components: {
					default: function() { return import( './components/Pages/JoinDouble.vue' ) }
				},
				meta: { backTop: false }
			}
		]
	},
	{
		path: '/',
		component: function() { return import( /* webpackChunkName: "Other" */ './views/OtherUnlogged.vue') },
		props: function(route) {
			return route.meta;
		},
		children: [
			{
				path: 'wait-login',
				name: 'UserLogin_',
				components: {
					default: function() { return import( './components/Pages/LoginWait.vue') }
				},
				meta: { backTop: false }
			},
			{
				path: 'login',
				name: 'UserLogin',
				components: {
					default: function() { return import( './components/Pages/Login.vue') }
				},
				meta: { backTop: false }
			},
			{
				path: 'the-login',
				name: 'UserLogin_',
				components: {
					default: function() { return import( './components/Pages/Login.vue') }
				},
				meta: { backTop: false }
			},
			{
				path: 'password-recovery',
				name: 'UserRecovery',
				components: {
					default: function() { return import( './components/Pages/Recovery.vue') }
				},
				meta: { backTop: false }
			},
			{
				path: 'recovery/:hash',
				name: 'UserRecoveryProcess',
				components: {
					default: function() { return import( './components/Pages/RecoveryProcess.vue') }
				},
				meta: { backTop: false }
			}
		]

	}],
	scrollBehavior: function(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			return {
				x: 0,
				y: 0
			}
		}
	}
})
